import {useLayoutEffect, useEffect, useMemo} from "react";
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
const useEnhancedEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function useForkRef(refA, refB) {
  return useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }
    return (refValue) => {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}
export {useEnhancedEffect as a, ownerDocument as o, setRef as s, useForkRef as u};
